import React from "react";
import withContentFallback from "../../utils/withContentFallback";
import { testimonialsContent } from "../../constants/homePageContent";
import "./TestimonialPreview.css";

const TestimonialPreview = ({ content }) => {
  // No need for manual fallback, content already processed by HOC
  const { heading, testimonials } = content;

  // Duplicate testimonials to create continuous scrolling effect
  const continuousTestimonials = [...testimonials, ...testimonials];

  // Ref for the testimonial slider
  const sliderRef = React.useRef(null);

  // State to control auto-sliding
  const [isAutoSliding, setIsAutoSliding] = React.useState(true);

  React.useEffect(() => {
    // Auto-sliding functionality for testimonials with continuous animation
    if (isAutoSliding && sliderRef.current) {
      // Create CSS animation for continuous sliding
      sliderRef.current.style.animation = "slide 30s linear infinite";
    } else if (sliderRef.current) {
      sliderRef.current.style.animationPlayState = "paused";
    }
  }, [isAutoSliding]);

  // Functions to control testimonial slider
  const pauseSlider = () => {
    if (sliderRef.current) {
      sliderRef.current.style.animationPlayState = "paused";
      setIsAutoSliding(false);
    }
  };

  const resumeSlider = () => {
    if (sliderRef.current) {
      sliderRef.current.style.animationPlayState = "running";
      setIsAutoSliding(true);
    }
  };

  return (
    <section className="testimonial-preview section animate-on-scroll">
      <div className="container">
        <h2 className="section-title">{heading}</h2>
        <div className="testimonial-track-container">
          <div
            className="testimonial-track"
            ref={sliderRef}
            onMouseEnter={pauseSlider}
            onMouseLeave={resumeSlider}
            onTouchStart={pauseSlider}
            onTouchEnd={resumeSlider}
          >
            {continuousTestimonials.map((testimonial, index) => (
              <div
                className="testimonial-card"
                key={`${testimonial.id || index}-${index}`}
                // The second copy only exists to make the marquee loop seamlessly.
                aria-hidden={index >= testimonials.length ? "true" : undefined}
              >
                <div className="testimonial-content">
                  <p>"{testimonial.content}"</p>
                  <div className="service-tags">
                    {testimonial.service &&
                      testimonial.service.split("&").map((service, i) => (
                        <span key={i} className="service-tag">
                          {service.trim()}
                        </span>
                      ))}
                  </div>
                </div>
                <div className="testimonial-author">
                  <div className="author-img">
                    <div className="avatar-placeholder">
                      {testimonial.initials ||
                        (testimonial.name && testimonial.name.charAt(0))}
                    </div>
                  </div>
                  <div className="author-info">
                    <h3>{testimonial.name || "Client"}</h3>
                    <p>{testimonial.location || ""}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

// Wrap the component with withContentFallback HOC
export default withContentFallback(TestimonialPreview, testimonialsContent);
